import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getSelectedRouteId = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routes.selectedId;

export const getDates = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routes.dates;

export const getRouteEntities = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routes.entities;

export const getLoading = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routes.loading;

export const getRouteIdsByDate = (date: string) => (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].routes.byDate[date];

export const getRoutes = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routes.entities;

export const getIds = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routes.ids;
